export default __webpack_public_path__ + "static/media/5.e11f344c.png";